import { Box } from "@mui/material";
import { Typography } from "src/components-mui/base/typography/typography";
import { HoverCard } from "src/components-mui/common/hover-card/hover-card";

export interface IRelatedWikifolioCardProps {
    title: string;
    label?: string;
    href: string;
    imageUrl: string;
}

export const RelatedWikifolioCard = ({ title, label, href, imageUrl }: IRelatedWikifolioCardProps) => (
    <HoverCard component="a" href={href} sx={{ width: "100%", height: "64px", alignItems: "center", justifyContent: "space-between" }}>
        <Box
            sx={{
                display: "flex",
                gap: 1,
                alignItems: "center",
                minWidth: 0,
            }}
        >
            <Box
                component="img"
                src={imageUrl}
                alt=""
                sx={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "100%",
                    flexShrink: 0,
                }}
            />
            <Typography
                noWrap
                sx={{
                    fontSize: "sm",
                    fontWeight: "bold",
                }}
            >
                {title}
            </Typography>
        </Box>
        {label ? (
            <Box
                sx={{
                    bgcolor: "gray.50",
                    borderRadius: "100px",
                    px: 1,
                    py: 0.5,
                    border: "1px solid var(--mui-palette-gray-100)",
                    flexShrink: 0,
                }}
            >
                <Typography
                    sx={{
                        fontSize: "10px",
                        fontWeight: "bold",
                    }}
                >
                    {label}
                </Typography>
            </Box>
        ) : null}
    </HoverCard>
);
